import React, { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedTable from 'components/LM/common/AdvancedTable';
import K2Api from 'lib/ajax/K2Api';
import DateFormat from "components/LM/common/DateFormat";
import RecoveryFormSearch from 'components/LM/Logs/Recoveries/FormSearch';
import Breadcrumb from 'components/LM/common/Breadcrumb';

import "./RecoveriesDisplay.scss";

const TABLE_COLUMNS = [
	{
		name: "id",
		alias: "Num"
	},
	{
		name: "requestor",
		alias: "Requestor"
	},
	{
		name: "profile_id",
		alias: "Profile id"
	},
	{
		name: "begin_date",
		alias: "Begin date"
	},
	{
		name: "end_date",
		alias: "End date"
	},
	{
		name: "status",
		alias: "Status"
	},
	{
		name: "status_message",
		alias: "Message"
	},
	{
		name: "inserted_at",
		alias: "Inserted at"
	},
	{
		name: "updated_at",
		alias: "Updated at"
	}
];

function RecoveriesDisplay(props) {
	const { type } = props;
	const [displayType, setDisplayType] = useState();
	const history = useHistory();

	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState();
	const [error, setError] = useState();

	useEffect(() => {
		// avoid twice calls
		if (!type || type === undefined || displayType) {
			return;
		};

		const search = async () => {
			setLoading(true)
			setResult(null)
			try {
				const response = await recoveriesSearch(type, { page: 1, pageSize: 20 });
				const gotResult = processResponse(response, type);
				setResult(gotResult);
			} catch (error) {
				setError(error);
			} finally {
				setLoading(false);
			}
		};
		search();
	}, [type, displayType]);

	const onFormChange = (inputDisplayType) => {
		setDisplayType(inputDisplayType);
		const params = new URLSearchParams({ type: inputDisplayType });
		history.replace({ search: params.toString() });
	};

	if (error) {
		return <Alert variant="danger">{error.toString()}</Alert>
	}

	return (
		<>
			<Breadcrumb items={['Logs Recoveries']} />
			<AdvancedTable
				columns={TABLE_COLUMNS}
				onSearch={params => recoveriesSearch(type || displayType, params)}
				onResults={(response) => processResponse(response, type)}
				data={result}
			>
				<RecoveryFormSearch type={type || displayType} onChange={onFormChange} loading={loading} />
			</AdvancedTable>
		</>
	);
}

async function recoveriesSearch(type, { page, pageSize }) {
	const from = (page - 1) * pageSize;
	const request = { from, size: pageSize };

	const k2Api = new K2Api();
	return (await k2Api.get(`/socialmedia/${type}/recovery`, { params: request })).data;
}

function processResponse(response, type) {
	const total = response.total;
	const rows = response.recoveries.map(row => {
		return {
			...row,
			id: row.id,
			begin_date: <DateFormat>{row.begin_date}</DateFormat>,
			end_date: <DateFormat>{row.end_date}</DateFormat>,
			inserted_at: <DateFormat>{row.inserted_at}</DateFormat>,
			updated_at: <DateFormat>{row.updated_at}</DateFormat>,
			profile_id: <a href={`/${type}/profile?id=${row.profile_id}`}>{row.profile_id}</a>
		}
	});

	return { total, rows };
}

RecoveriesDisplay.propTypes = {
	type: PropTypes.string
}

export default RecoveriesDisplay;
